import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../../apollo-client';
import {appHistory} from '../../../../../history';
import {store} from '../../../../../store';

import {DromoQuotaImporter} from './dromo-quota-importer';

export function mountDromoQuotaImporter() {
    const dromoQuotaImporterContainer = document.querySelector('#quota-importer-react-mount');

    if (dromoQuotaImporterContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <DromoQuotaImporter />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            dromoQuotaImporterContainer
        );
    }
}
